import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

/** Messages, with the shared invite link as an incoming iMessage. */
export function MessagesApp({ v }: { v: Vals }) {
  return (
    <div style={sx('position:absolute;inset:0;padding-top:56px;display:flex;flex-direction:column;background:#000')}>
      <div
        style={sx(
          'padding:6px 16px 12px;display:flex;align-items:center;gap:10px;' +
            'border-bottom:1px solid rgba(255,255,255,.08)'
        )}
      >
        <Hov
          as="button"
          onClick={v.kBackToLock}
          style={sx(
            'padding:0;border:none;background:transparent;cursor:pointer;display:flex;flex:none'
          )}
          hoverStyle={sx('opacity:.7')}
        >
          <span
            style={sx(
              'width:16px;height:16px;background:#0a84ff;' +
                '-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;' +
                'mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat'
            )}
          />
        </Hov>
        <span style={sx('flex:1;font-size:var(--fs-sm);font-weight:var(--fw-medium);color:#fff;text-align:center')}>
          {v.managerEmailAddress}
        </span>
        <span style={sx('width:16px;flex:none')} />
      </div>

      <div style={sx('flex:1;min-height:0;overflow:auto;padding:18px 16px;display:flex;flex-direction:column;gap:8px')}>
        <span style={sx('font-size:var(--fs-2xs);color:rgba(255,255,255,.4);text-align:center;margin-bottom:4px')}>
          Today 9:41
        </span>

        <span
          style={sx(
            'max-width:78%;align-self:flex-start;padding:10px 14px;border-radius:18px;' +
              'background:#26262a;color:#fff;font-size:var(--fs-sm);line-height:20px'
          )}
        >
          Sorted you a seat on my NordVPN plan
        </span>

        {/* The link is the whole point of this screen, so it is the tap target. */}
        <Hov
          as="button"
          onClick={v.kOpenSignup}
          style={sx(
            'max-width:82%;align-self:flex-start;padding:0;border:none;background:transparent;' +
              'cursor:pointer;font-family:inherit;text-align:left;display:flex'
          )}
          hoverStyle={sx('opacity:.85')}
        >
          <span
            style={sx(
              'padding:10px 14px;border-radius:18px;background:#26262a;display:flex;' +
                'flex-direction:column;gap:8px;width:100%'
            )}
          >
            <span
              style={sx(
                'font-size:var(--fs-sm);line-height:20px;color:#0a84ff;' +
                  'text-decoration:underline;word-break:break-all'
              )}
            >
              nordaccount.com/join/8FQ2-14KD
            </span>
            <span
              style={sx(
                'padding:10px;border-radius:12px;background:rgba(255,255,255,.06);' +
                  'display:flex;align-items:center;gap:10px'
              )}
            >
              <span
                style={sx(
                  'width:32px;height:32px;flex:none;border-radius:8px;background:var(--bg-accent);' +
                    'display:flex;align-items:center;justify-content:center'
                )}
              >
                <span
                  style={sx(
                    'width:17px;height:17px;background:#fff;' +
                      '-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;' +
                      'mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat'
                  )}
                />
              </span>
              <span style={sx('flex:1;display:flex;flex-direction:column;gap:1px;min-width:0')}>
                <span style={sx('font-size:var(--fs-xs);font-weight:var(--fw-medium);color:#fff')}>
                  Join a NordVPN group
                </span>
                <span style={sx('font-size:var(--fs-2xs);color:rgba(255,255,255,.5)')}>
                  nordaccount.com
                </span>
              </span>
            </span>
          </span>
        </Hov>
      </div>
    </div>
  )
}
